module.exports = __webpack_public_path__ + "98e68e82219a2d1a186efe5a373aa004.jpg";